import { FormService } from "./form.service";

/***
 * This is the local backend implementation that uses the downloaded metadata to get data.
 */
export class FormServiceLocal implements FormService {
    public submitForm = async (
        _site: string,
        _name: string,
        _data: { [key: string]: string | boolean },
    ): Promise<{ success: boolean, message: string | null }> => {
        // Local downloads should not use forms
        return { success: true, message: "" };
    }
}
